export default {
  methods: {
    async init() {
      await this.$store.dispatch("cmstag/getTags");
    }
  }
};
